import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { ROUTE_PATHS } from '../../routing/routes.pojo';
import { Permission } from '../interfaces/permission.pojo';
import { UserData } from '../services/state/user-data';

interface PermissionGuardData {
  permission: Permission;
  redirectTo?: string;
}

export const permissionGuard: CanActivateFn = (route) => {
  const userStore = inject(UserData);
  const router = inject(Router);

  const data = route.data as PermissionGuardData;
  const redirectTo = data.redirectTo ?? ROUTE_PATHS.home;

  const hasAccess = userStore.hasPermission(data.permission);

  if (!hasAccess) {
    console.warn('Access denied: insufficient permissions');
    return router.parseUrl(redirectTo);
  }

  return true;
};
